import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // ⭐ SEO: Set title + noindex
  useEffect(() => {
    document.title = "Admin Login";

    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // ✔ Call correct ADMIN API
      const res = await axios.post(`${API}/auth/admin/login`, { email, password });

      const token = res.data.access_token;
      const user = res.data.user;

      // Save admin token separately
      localStorage.setItem("admin_token", token);
      localStorage.setItem("admin_user", JSON.stringify(user));

      toast.success("Admin login successful!");

      // Redirect to hidden panel
      navigate("/starmoonlight/panel");

    } catch (error) {
      toast.error(error.response?.data?.detail || "Admin login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="glass-background"></div>

      <div className="auth-box glass-panel fade-in">
        <div className="auth-header">
          <h1>Admin Login</h1>
          <p>Restricted Area</p>
        </div>

        <form onSubmit={handleAdminLogin} className="auth-form">
          <div className="form-group">
            <Label>Email</Label>
            <Input
              type="email"
              className="glass-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <Label>Password</Label>
            <Input
              type="password"
              className="glass-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <Button type="submit" disabled={loading} className="glass-btn">
            {loading ? "Verifying..." : "Login"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
